import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const EditPatchPage = lazy(
  () => import('@/features/Servers/pages/EditPatchPage'),
)

export const Route = createFileRoute('/infra/servers/$id/patches/$patchId')({
  beforeLoad: protectedRouteGuard,
  loader: ({ params }) => ({
    crumb: `Edit Patch ${params.patchId}`,
  }),
  component: () => (
    <Suspense fallback={<Loading />}>
      <EditPatchPage />
    </Suspense>
  ),
})
